import { AuthService } from '@core/services/auth.service';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { HasRoleDirective } from '../../directives/has-role.directive';
import { AsyncPipe, UpperCasePipe, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    MatDivider,
    MatButton,
    MatIcon,
    HasRoleDirective,
    AsyncPipe,
    UpperCasePipe,
    TitleCasePipe,
  ],
})
export class SidebarComponent {
  private authService = inject(AuthService);

  private router = inject(Router);

  @Output() shouldCloseSidebar: EventEmitter<void> = new EventEmitter<void>();

  user$ = this.authService.user$;

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  navigateTo(path: string[]): void {
    this.router.navigate(path);
    this.shouldCloseSidebar.emit();
  }
}
